import joinClasses from "helpers/joinClasses";

export function Title({ children, className }) {
  return (
    <h1
      className={joinClasses(
        "font-tt-ramillas-trl-bold text-[50px] leading-[80px]",
        className
      )}
    >
      {children}
    </h1>
  );
}
